<template>
  <div>
    <div>web test</div>
    <div class="section-labelaudio">
      <div class="labelaudio">
        <audioWave
          :PropsStatus="PropsStatus"
          :PropsAudioUrl="PropsAudioUrl"
          :PropsBatchDate="PropsBatchDate"
          :PropsAudioName="PropsAudioName"
          :PropsHasLabeled="PropsHasLabeled"
          @feedbackDataToParent="getBackFromChild"
        ></audioWave>
        <div class="labelaudio__option">
          <div class="option">
            <div class="option__status">
              <input type="radio" name="option" id="cry" v-model="PropsStatus" value="cry" />
              <label for="cry" class="option__status--font">Cry (keycode : Q)</label>
            </div>
            <div class="option__status">
              <input type="radio" name="option" id="talk" value="talk" v-model="PropsStatus" />
              <label for="talk" class="option__status--font">Talk (keycode : W)</label>
            </div>
            <div class="option__status">
              <input
                type="radio"
                name="option"
                id="cry_talk"
                value="cry_talk"
                v-model="PropsStatus"
              />
              <label for="cry_talk" class="option__status--font">
                  Cry &amp; Talk (keycode : E)</label>
            </div>
            <div class="option__status">
              <input type="radio" name="option" id="music" value="music" v-model="PropsStatus" />
              <label for="music" class="option__status--font">Music (keycode : R)</label>
            </div>
            <div class="option__status">
              <input type="radio" name="option" id="echo" value="echo" v-model="PropsStatus" />
              <label for="echo" class="option__status--font">Echo (keycode : T)</label>
            </div>
            <div class="option__status">
              <input type="radio" name="option" id="other" value="other" v-model="PropsStatus" />
              <label for="other" class="option__status--font">Other (keycode : Y)</label>
            </div>
          </div>
          <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="skip()">
              Skip</button>
          <button
            class="btn btn-secondary mg-r-ten btn-fashion"
            @click.prevent="backward()"
            :disabled="current===1"
          >
            <i class="fas fa-backward"></i>
          </button>
          <button
            class="btn btn-secondary mg-r-ten btn-fashion"
            :disabled="total===current"
            @click.prevent="forward()"
          >
            <i class="fas fa-forward"></i>
          </button>
          <button class="btn btn-primary btn-fashion" @click.prevent="next()">
              Store &amp; Next</button>
          <div style="text-align:right;">{{current}} / {{total}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audioWave from '@/components/audioWave/index.vue';

export default {
  components: { audioWave },
  data() {
    return {
      dataGetBackFromChild: [],
      PropsStatus: 'cry',
      PropsAudioUrl: null,
      PropsBatchDate: '',
      PropsAudioName: '',
      PropsHasLabeled: [],
      batch: {
        batchType: 'audio',
        batchDate: '',
        audioName: '',
      },
      current: 0, // 當前頁碼
      total: 0, // 總頁碼
      storeAudioName: [], // 從API已拿到所有的 audioName
    };
  },
  methods: {
    // 接audioWave component emit 過來的資料
    getBackFromChild(data) {
      const vm = this;
      vm.dataGetBackFromChild = data;
      // console.log('parent');
      // console.log(vm.dataGetBackFromChild);
    },
    nextLabel() {
      // get next label meta
      const vm = this;
      if (vm.current < vm.total) {
        vm.current += 1;

        const data = {
          name: vm.storeAudioName[vm.current - 1],
          type: vm.batch.batchType,
        };
        vm.$store.dispatch('assignmeta', data).then((response) => {
          vm.PropsAudioUrl = `${process.env.VUE_APP_API}/data/audio/${response.batch_date}/${response.name}`;
          vm.PropsBatchDate = response.batch_date;
          vm.PropsAudioName = response.name;
          vm.PropsHasLabeled = response.segments;
        });
      } else {
        vm.$store.dispatch('Gettask', vm.batch.batchType).then((response) => {
          vm.PropsBatchDate = response.batch_date;
          vm.PropsAudioName = response.name;
          vm.PropsAudioUrl = `${process.env.VUE_APP_API}/data/audio/${response.batch_date}/${response.name}`;
          vm.storeAudioName.push(vm.PropsAudioName);
          vm.current += 1;
          vm.total += 1;
        });
      }
    },
    next() {
      // put label meta to api
      const vm = this;

      vm.PropsHasLabeled = [];
      const data = {
        name: vm.storeAudioName[vm.current - 1],
        skip: false,
        segments: [],
      };
      for (let k = 0; k < vm.dataGetBackFromChild.length; k += 1) {
        data.segments.push({
          class: vm.dataGetBackFromChild[k].status,
          start_ms: vm.dataGetBackFromChild[k].start,
          end_ms: vm.dataGetBackFromChild[k].end,
        });
      }
      vm.$store.dispatch('labeltime', data).then(() => {
        vm.dataGetBackFromChild = [];
        vm.nextLabel();
      });
    },
    skip() {
      // skip the label
      const vm = this;
      // vm.PropsHasLabeled = [];
      const data = {
        name: vm.PropsAudioName,
        skip: true,
        segments: vm.PropsHasLabeled,
      };
      vm.PropsHasLabeled = [];
      vm.$store.dispatch('labeltime', data).then(() => {
        vm.nextLabel();
      });
    },
    backward() {
      // 倒退
      const vm = this;
      vm.PropsHasLabeled = [];
      if (vm.current !== 1) {
        vm.current -= 1;
        const data = {
          name: vm.storeAudioName[vm.current - 1],
          type: vm.batch.batchType,
        };
        vm.$store.dispatch('assignmeta', data).then((response) => {
          vm.PropsAudioUrl = `${process.env.VUE_APP_API}/data/audio/${response.batch_date}/${response.name}`;
          // console.log('backward: ');
          // console.log(response);
          vm.PropsBatchDate = response.batch_date;
          vm.PropsAudioName = response.name;
          if (response.segments) {
            vm.PropsHasLabeled = response.segments;
            // console.log('back');
            // console.log(vm.PropsHasLabeled);
          }
        });
      }
    },
    forward() {
      // 前進
      const vm = this;
      vm.current += 1;
      vm.PropsHasLabeled = [];

      const data = {
        name: vm.storeAudioName[vm.current - 1],
        type: vm.batch.batchType,
      };
      vm.$store.dispatch('assignmeta', data).then((response) => {
        vm.PropsAudioUrl = `${process.env.VUE_APP_API}/data/audio/${response.batch_date}/${response.name}`;
        // console.log('forward: ');
        // console.log(response);
        vm.PropsBatchDate = response.batch_date;
        vm.PropsAudioName = response.name;
        if (response.segments) {
          vm.PropsHasLabeled = response.segments;
          // console.log('forward');
          // console.log(vm.PropsHasLabeled);
        }
      });
    },
  },
  mounted() {
    const vm = this;
    vm.nextLabel();
    document.onkeydown = function (e) {
      const keycode = {
        KeyQ: () => {
          vm.PropsStatus = 'cry';
          // console.log(vm.PropsStatus);
        },
        KeyW: () => {
          vm.PropsStatus = 'talk';
          // console.log(vm.PropsStatus);
        },
        KeyE: () => {
          vm.PropsStatus = 'cry_talk';
          // console.log(vm.PropsStatus);
        },
        KeyR: () => {
          vm.PropsStatus = 'music';
          // console.log(vm.PropsStatus);
        },
        KeyT: () => {
          vm.PropsStatus = 'echo';
          // console.log(vm.PropsStatus);
        },
        KeyY: () => {
          vm.PropsStatus = 'other';
          // console.log(vm.PropsStatus);
        },
        Escape: () => {
          vm.hidebox();
        },
        ArrowUp: () => {
          vm.skip();
        },
        Enter: () => {
          vm.next();
        },
        ArrowLeft: () => {
          vm.backward();
        },
        ArrowRight: () => {
          vm.forward();
        },
      };
      keycode[e.code]();
    };
  },
};
</script>
